/* Localization for comboBox fillable element */
export const COMBOBOX_SETTINGS_SIDEBAR = {
    COMBO_BOX_SETTINGS_TITLE: {
        key: 'COMBO_BOX_SETTINGS_TITLE',
        value: 'ComboBox Settings'
    },
    COMBO_BOX_GROUP_SETTINGS_TITLE: {
        key: 'COMBO_BOX_GROUP_SETTINGS_TITLE',
        value: 'ComboBox Group Settings'
    },
    FIELD_NAME_LABEL: {
        key: 'FIELD_NAME_LABEL',
        value: 'Field name'
    },
    FIELD_NAME_PLACEHOLDER: {
        key: 'FIELD_NAME_PLACEHOLDER',
        value: 'Enter the field name'
    },
    FIELD_NAME_SPECIAL_CHARACTER_ERROR_MESSAGE: {
        key: 'FIELD_NAME_SPECIAL_CHARACTER_ERROR_MESSAGE',
        value: 'Field name cannot contain any special characters or spaces other than hyphen(-)'
    },
    FIELD_NAME_EXISTS_ERROR_MESSAGE: {
        key: 'FIELD_NAME_EXISTS_ERROR_MESSAGE',
        value: 'Enter a unique field name. {{fieldName}} field name already exists!'
    },
    IS_DYNAMIC_LABEL: {
        key: 'IS_DYNAMIC_LABEL',
        value: 'Is Dynamic'
    },
    VALUES_LIST_LABEL: {
        key: 'VALUES_LIST_LABEL',
        value: 'Values'
    },
    DYNAMIC_VALUES_LABEL: {
        key: 'DYNAMIC_VALUES_LABEL',
        value: 'Values'
    },
    VARIABLE_SELECT_PLACEHOLDER: {
        key: 'VARIABLE_SELECT_PLACEHOLDER',
        value: 'Select a variable'
    },
    DYNAMIC_LABEL_YES_SWITCH: {
        key: 'DYNAMIC_LABEL_YES_SWITCH',
        value: 'Yes'
    },
    DYNAMIC_LABEL_NO_SWITCH: {
        key: 'DYNAMIC_LABEL_NO_SWITCH',
        value: 'No'
    },
    NEW_VALUE_LABEL: {
        key: 'NEW_VALUE_LABEL',
        value: 'Value'
    },
    COMBOBOX_PLACEHOLDER_LABEL: {
        key: 'COMBOBOX_PLACEHOLDER_LABEL',
        value: 'Select a value'
    },
    IS_VARIABLE_LABEL: {
        key: 'IS_VARIABLE_LABEL',
        value: 'do you want to set the default value dynamically?'
    }
};

export const COMBOBOX_VALUES_TABLE_SETTINGS = {
    ADD_A_VALUE_ACTION: {
        key: 'ADD_A_VALUE_ACTION',
        value: 'Add a value'
    },
    SAVE_TOOLTIP: {
        key: 'SAVE_TOOLTIP',
        value: 'Save'
    },
    CANCEL_TOOLTIP: {
        key: 'CANCEL_TOOLTIP',
        value: 'Cancel'
    },
    EDIT_TOOLTIP: {
        key: 'EDIT_TOOLTIP',
        value: 'Edit'
    },
    DELETE_TOOLTIP: {
        key: 'DELETE_TOOLTIP',
        value: 'Delete'
    },
    DELETE_CONFIRM_CONFIRMATION_MESSAGE: {
        key: 'DELETE_CONFIRM_CONFIRMATION_MESSAGE',
        value: 'Sure to delete?'
    },
    ENTER_A_VALUE_ERROR_MESSAGE: {
        key: 'ENTER_A_VALUE_ERROR_MESSAGE',
        value: 'Please enter value!'
    }
};